import { FC, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Label,
  Row,
  Table,
} from "reactstrap";
import ModalComponent from "../../shared/base-components/Modal";
import TextField from "../../shared/base-components/TextField";
import { SubmitHandler, useForm } from "react-hook-form";
import Button from "../../shared/base-components/Button";
import {
  useCustomerAllPaymentOrdersMutation,
  useCustomerPaymentAddMutation,
  useCustomerPaymentInstallmentAddMutation,
} from "./CustomerProfile.actions";
import { getItem } from "../../shared/hooks/useCookie";
import {
  CustomerAllPaymentRequest,
  CustomerAllPaymentResponse,
  CustomerPaymentRequest,
  paymentDetailSchema,
} from "./CustomerProfile.constants";
import { Permissions, RESPONSE_CODE } from "../../shared/models/Types";
import { successNotify } from "../../shared/utils/notifications";
import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import SelectBox from "../../shared/base-components/SelectBox";
import { payOptions } from "../Stock/Stock.constants";
import { formatDecimal } from "../../shared/utils/formatText";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../shared/actions/Authentication.actions";
import Switch from "../../shared/base-components/Switch";
import DatePicker from "../../shared/base-components/DatePicker";

interface CustomerPaymentDetailModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalOptions: { id?: number };
  allPayments: CustomerAllPaymentResponse | undefined;
  mutate: UseMutateFunction<
    CustomerAllPaymentResponse,
    AxiosError<any>,
    CustomerAllPaymentRequest,
    unknown
  >;
}

const CustomerPaymentDetailModal: FC<CustomerPaymentDetailModalProps> = ({
  isModalOpen,
  toggle,
  modalOptions,
  allPayments,
  mutate,
}) => {
  const permissionList = useRecoilValue(permissionsSelector);

  const customerProfileId = getItem("customerProfileId");

  const selectedPayment = allPayments?.results.find(
    (payment) => payment.id == modalOptions.id
  );

  const {
    data,
    mutate: customerAllPaymentOrdersMutation,
    isLoading,
  } = useCustomerAllPaymentOrdersMutation();
  const { data: customerPaymentAddData, mutate: customerPaymentAddMutation } =
    useCustomerPaymentAddMutation();

  const {
    data: customerPaymentInstallmentData,
    mutate: customerPaymentInstallmentMutation,
    isLoading: customerPaymentInstallmentLoading,
  } = useCustomerPaymentInstallmentAddMutation();

  const [hasPaymentDate, setHasPaymentDate] = useState(false);
  const [selectedDate, setSelectedDate] = useState<string>();

  console.log(data);

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<any>({
    resolver: yupResolver(
      paymentDetailSchema(
        selectedPayment?.retrieval
          ? parseInt(selectedPayment?.retrieval)
          : 9999999999
      )
    ),
  });

  const onSubmit: SubmitHandler<any> = (
    requestFormValues: CustomerPaymentRequest
  ) => {
    if (selectedPayment?.id && modalOptions.id) {
      customerPaymentAddMutation({
        ...requestFormValues,
        payment: modalOptions.id,
        payment_type: parseInt(requestFormValues.payment_type),
        is_paid: true,
        is_partial: false,
        next_payment_date: requestFormValues?.next_payment_date || undefined,
      });
    }
  };

  const installmentPayHandler = (installmentId: number, isPaid: boolean) => {
    if (selectedPayment?.id && modalOptions.id) {
      customerPaymentInstallmentMutation({
        paymentId: installmentId,
        payment: modalOptions.id,
        payment_type: 1,
        is_paid: isPaid,
      });
    }
  };

  const paymentsWithDate = data?.results.filter((p) => p.payment_date != null);

  const sortedPayments =
    paymentsWithDate &&
    paymentsWithDate.sort((a, b) =>
      a.payment_date.localeCompare(b.payment_date)
    );

  const isPreviousPaymentsDone = (index: number, payments: any) => {
    for (let i = 0; i < index; i++) {
      if (!payments[i].is_paid) {
        return false;
      }
    }
    return true;
  };

  const isNextPaymentsNotDone = (index: number, payments: any) => {
    for (let i = index + 1; i < payments.length; i++) {
      if (payments[i].is_paid) {
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    modalOptions.id &&
      !customerPaymentInstallmentLoading &&
      customerAllPaymentOrdersMutation({ id: modalOptions.id });
  }, [customerPaymentInstallmentLoading]);

  useEffect(() => {
    if (
      customerPaymentAddData?.status === RESPONSE_CODE.CREATED ||
      customerPaymentInstallmentData?.status === RESPONSE_CODE.SUCCESS_CODE
    ) {
      // if (
      //   customerPaymentAddData?.status === RESPONSE_CODE.CREATED &&
      //   hasPaymentDate &&
      //   parseInt(selectedPayment?.retrieval || "0") !==
      //     parseInt(watch("amount"))
      // ) {
      //   customerPaymentAddMutation({
      //     amount:
      //       parseInt(selectedPayment?.retrieval || "0") -
      //       parseInt(watch("amount")),
      //     payment: selectedPayment?.id,
      //     payment_type: 1,
      //     is_paid: false,
      //     is_partial: false,
      //     payment_date: watch("paymentDate"),
      //   });
      // }
      successNotify("Ödeme başarılı!");
      toggle();
      mutate({ id: customerProfileId });
    }
  }, [customerPaymentAddData, customerPaymentInstallmentData]);

  const viewPaidOrderPermission = permissionList[Permissions.ViewPaidorder];
  const updatePaidOrderPermission = permissionList[Permissions.ChangePaidorder];
  const deletePaidOrderPermission = permissionList[Permissions.DeletePaidorder];

  return (
    <ModalComponent
      header="Ödeme Yap"
      description="Ödeme yapmak için gerekli alanları doldurunuz."
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        {selectedPayment?.payment_type == "ap" ? (
          <Row>
            {viewPaidOrderPermission && (
              <Card>
                <CardBody>
                  <div className="pb-3">
                    <Row>
                      <Col>
                        <div>
                          <h5 className="font-size-15">Yapılan İş Ücreti:</h5>
                        </div>
                      </Col>

                      <Col>
                        <div className="text-muted">
                          <p className="mb-2">
                            {formatDecimal(selectedPayment?.amount)} ₺
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="pb-3">
                    <Row>
                      <Col>
                        <div>
                          <h5 className="font-size-15">Alınan Ücret:</h5>
                        </div>
                      </Col>

                      <Col>
                        <div className="text-muted">
                          <p className="mb-2">
                            {formatDecimal(
                              parseInt(selectedPayment?.total_paid)
                            )}{" "}
                            ₺
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="pb-3">
                    <Row>
                      <Col>
                        <div>
                          <h5 className="font-size-15">Kalan Ücret:</h5>
                        </div>
                      </Col>

                      <Col>
                        <div className="text-muted">
                          <p className="mb-2">
                            {formatDecimal(
                              parseInt(selectedPayment?.retrieval)
                            )}{" "}
                            ₺
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            )}

            <Col sm="12" md="6" lg="6">
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Ödenecek Tutar</Label>
                <TextField
                  control={control}
                  name="amount"
                  className="form-control"
                  type="number"
                  placeholder="Ödenecek Tutar"
                  error={errors.amount?.message}
                />
              </FormGroup>
            </Col>

            <Col sm="12" md="6" lg="6">
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Ödeme Tipi</Label>
                <SelectBox
                  control={control}
                  name="payment_type"
                  className="form-control"
                  defaultValue={1}
                  options={payOptions}
                />
              </FormGroup>
            </Col>

            <Col sm="12" md="6" lg="6">
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Not</Label>
                <TextField
                  control={control}
                  name="note"
                  className="form-control"
                  type="text"
                  placeholder="Not"
                  error={errors.note?.message}
                />
              </FormGroup>
            </Col>

            <Col sm="12" md="6" lg="6"></Col>

            <Col sm="12" md="6" lg="6">
              <FormGroup>
                <Label style={{ margin: 0 }} htmlFor="validationCustom02">
                  Sonraki Ödeme Tarihi
                </Label>
              </FormGroup>
              <Switch
                onChangeHandler={(e: any) => setHasPaymentDate(e)}
                control={control}
                defaultValue={false}
                name="has_next_Payment_date"
              />
            </Col>

            <Col sm="12" md="6" lg="6">
              {hasPaymentDate && (
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom02">Tarih</Label>
                  <DatePicker
                    control={control}
                    name="next_payment_date"
                    className="form-control"
                    type="text"
                    defaultValue={new Date()}
                  />
                </FormGroup>
              )}
            </Col>

            <Col md="12">
              <FormGroup className="mb-3">
                {updatePaidOrderPermission && (
                  <Button
                    loading={isLoading}
                    text="Ödeme Yap"
                    variant="primary"
                  />
                )}
              </FormGroup>
            </Col>
          </Row>
        ) : (
          <CardBody>
            <div className="p-4 border rounded">
              <div className="table-responsive">
                <Table className="table-nowrap align-middle mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: "70px" }}>Taksit</th>
                      <th>Ücret/Tarih</th>
                      <th className="text-end" style={{ width: "120px" }}>
                        İşlem
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedPayments &&
                      updatePaidOrderPermission &&
                      sortedPayments.map((payments, index) => {
                        const canPay = isPreviousPaymentsDone(
                          index,
                          sortedPayments
                        );

                        const canCancel =
                          payments.is_paid &&
                          isNextPaymentsNotDone(index, sortedPayments);

                        if (payments.payment_date != null) {
                          return (
                            <tr key={payments.id}>
                              <td>{index + 1 + ". Taksit"}</td>
                              <td>
                                <h5 className="font-size-15 mb-1">
                                  {formatDecimal(payments?.amount)} TL
                                </h5>
                                <p className="font-size-13 text-muted mb-0">
                                  {payments.payment_date != null &&
                                    payments?.payment_date.split("T")[0]}
                                </p>
                              </td>
                              <td className="text-end">
                                {!payments.is_paid && canPay ? (
                                  <span
                                    onClick={() => {
                                      installmentPayHandler(payments?.id, true);
                                    }}
                                    className="badge btn btn-success rounded-pill font-size-10 p-2 pointer"
                                  >
                                    Ödeme Yap
                                  </span>
                                ) : canCancel ? (
                                  <span
                                    onClick={() => {
                                      deletePaidOrderPermission &&
                                        installmentPayHandler(
                                          payments.id,
                                          false
                                        );
                                    }}
                                    className="badge btn btn-danger rounded-pill font-size-10 p-2 pointer"
                                  >
                                    İptal Et
                                  </span>
                                ) : (
                                  <span
                                    className={`badge btn ${
                                      !canPay ? "btn-danger" : "btn-success"
                                    } rounded-pill font-size-10 p-2 pointer`}
                                    style={{
                                      cursor: "not-allowed",
                                      opacity: 0.5,
                                    }}
                                  >
                                    {!canPay
                                      ? "Önceki Ödeme Gerekiyor"
                                      : "Ödendi"}
                                  </span>
                                )}
                              </td>
                            </tr>
                          );
                        }
                      })}
                  </tbody>
                </Table>
              </div>
            </div>
          </CardBody>
        )}
      </Form>
    </ModalComponent>
  );
};

export default CustomerPaymentDetailModal;
